import {default as React} from "react";
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import {CardObject} from "../../../types.d";

interface TopicModalProps {
    card: CardObject;
    visible: boolean;
    toggle: () => any;
}

export const TopicModal = (props: TopicModalProps) => {
    const { card } = props;

    return <Modal isOpen={props.visible}
                  className={'large-modal'}
                  toggle={props.toggle}>
        <ModalHeader toggle={props.toggle}>Topic Block Overview: { card.topic.title }</ModalHeader>
        <ModalBody>
            <h4>Description</h4>

            <div className={'topic-content-preview'} dangerouslySetInnerHTML={{
                __html: card.topic.description
            }} />
        </ModalBody>
    </Modal>
};
